import React from "react";
import { EXHIBITIONS } from "../data/site";

export default function ExhibitionHistory() {
  const today = new Date().toISOString().slice(0, 10);
  const concluded = EXHIBITIONS.upcoming
    .filter((ex) => ex.calendar?.end && ex.calendar.end.slice(0, 10) < today)
    .map((ex) => ({
      id: ex.id,
      title: ex.title,
      venue: ex.location.split(" · ")[0],
      address: ex.location.split(" · ").slice(1).join(" · "),
      dates: ex.meta,
      note: ex.badge,
      image: ex.image,
    }));
  const past = [...concluded, ...EXHIBITIONS.past];
  return (
    <section
      className="border-t border-border"
      data-testid="exhibition-history"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <header className="mb-12 md:mb-16">
          <p className="label mb-3">003 — Exhibition History</p>
          <h2 className="serif text-4xl md:text-5xl tracking-tight font-light">
            Selected showings.
          </h2>
        </header>

        <ul className="divide-y divide-border border-y border-border">
          {past.map((ex) => (
            <li
              key={ex.id}
              className="grid grid-cols-12 gap-4 md:gap-8 py-6 md:py-8 items-center"
              data-testid={`past-${ex.id}`}
            >
              <div className="col-span-3 md:col-span-2">
                <div className="aspect-square overflow-hidden bg-[hsl(var(--surface))]">
                  <img
                    src={ex.image}
                    alt={ex.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="col-span-9 md:col-span-5">
                <h3 className="serif text-2xl md:text-3xl tracking-tight">
                  {ex.title}
                </h3>
                <p className="label mt-1">{ex.note}</p>
              </div>
              <div className="col-span-12 md:col-span-3 text-sm text-[hsl(var(--ink-soft))]">
                <p className="font-medium text-foreground">{ex.venue}</p>
                <p>{ex.address}</p>
              </div>
              <div className="col-span-12 md:col-span-2 text-sm text-[hsl(var(--ink-soft))] md:text-right">
                {ex.dates}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
